import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../styles/EditarListaDeEmpaqueModal.css";
import "../styles/Historico.css"; // [EXPERT_FIX]: Importar estilos
//import TotalesEncabezadoListaEmpaque from "../Componentes/Totalesencabezadolistaempaque";
import TotalesEncabezadoHistoricoContenedor from "../Componentes/TotalesEncabezadoHistoricoContenedor";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

//const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const translations = {
  es: {
    titulo: "Historico Lista de Empaque",
    cancelar: "Cancelar",
    guardar: "Guardar",
    advertencia: "Advertencia",
    noDatos: "No hay datos cargados.",
    guardadoExito: "Datos guardados con éxito.",
    guardadoError: "Error al guardar los datos.",
  },
  en: {
    titulo: "Packing List Record",
    cancelar: "Cancel",
    guardar: "Save",
    advertencia: "Warning",
    noDatos: "No data loaded.",
    guardadoExito: "Data saved successfully.",
    guardadoError: "Error saving data.",
  },
  zh: {
    titulo: "编辑装箱单",
    cancelar: "取消",
    guardar: "保存",
    advertencia: "警告",
    noDatos: "未加载数据。",
    guardadoExito: "数据保存成功。",
    guardadoError: "保存数据时出错。",
  },
};

// **Encabezados esperados con anchos optimizados**
const columnasEsperadas = [
  { field: "nroCaja", header: "NRO CAJA", width: "80px" },
  { field: "RefInterna", header: "REF PRODUCTO", width: "120px" },
  { field: "RefProveedor", header: "REF PROVEEDOR", width: "120px" },
  { field: "ImagenProducto", header: "FOTO", width: "80px" },
  { field: "MarcaCaja", header: "MARCA", width: "100px" },
  { field: "Descripcion", header: "DESCRIPCION", width: "220px" },
  { field: "Material", header: "MATERIAL", width: "100px" },
  { field: "Serial", header: "SERIAL", width: "100px" },
  { field: "MarcaProducto", header: "MARCA (PRODUCTO)", width: "120px" },
  { field: "UnidadMedida", header: "UNIDAD MEDIDA", width: "90px" },
  { field: "Modelo", header: "MODELO", width: "100px" },
  { field: "PesoBruto", header: "PESO BRUTO", width: "95px" },
  { field: "CantCajas", header: "CANT CAJAS", width: "85px" },
  { field: "CantPiezasPorCaja", header: "PCS / CAJA", width: "85px" },
  { field: "CantTotal", header: "CANT TOTAL", width: "85px" },
  { field: "CBMTotal", header: "CBM TOTAL", width: "85px" },
  { field: "CubCaja", header: "CUBICAJE / CAJA", width: "100px" },
  { field: "PesoCaja", header: "PESO / CAJA", width: "90px" },
  { field: "TipoMcia", header: "TIPO MCIA", width: "80px" },
  { field: "Importador", header: "IMPORTADOR", width: "110px" },
  { field: "IdListaEmpaque", header: "ID LE", width: "70px" },
  { field: "idpedido", header: "ID PEDIDO", width: "80px" },
  { field: "IdContenedor", header: "ID CTN", width: "70px" },
  { field: "EstadoProductoLE", header: "ESTADO LE", width: "90px" },
  { field: "Clasificacion", header: "CLASF LE", width: "90px" },
];

const HistoricoContenedorModal = ({
  isOpen,
  onClose,
  Contenedor,
  language,
}) => {
  const [previewData, setPreviewData] = useState([]); // Datos cargados para previsualización
  const [expandedRows, setExpandedRows] = useState([]); // [EXPERT]: Inicializar como array vacío para estabilidad
  const toast = React.useRef(null);

  const t = translations[language] || translations.es;

  // Función para agrupar los datos por contenedor y luego por pedido
  const groupDataByPedido = (data) => {
    const groupedByPedido = data.reduce((acc, item) => {
      const pedidoId = item.idpedido || "Sin Pedido";
      if (!acc[pedidoId]) {
        acc[pedidoId] = {
          idpedido: pedidoId,
          productos: [],
        };
      }
      acc[pedidoId].productos.push(item);
      return acc;
    }, {});

    // Convertir el objeto anidado a un array de pedidos
    return Object.values(groupedByPedido);
  };

  useEffect(() => {
    if (isOpen && Contenedor?.IdContenedor) {
      fetchWithAuth(
        `${API_URL}/api/hcontenedores?IdContenedor=${Contenedor.IdContenedor}`,
      )
        .then((response) => response.json())
        .then((data) => {
          const groupedData = groupDataByPedido(data);
          setPreviewData(groupedData);
        })
        .catch((err) => {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: t.guardadoError,
              detail: t.guardadoError,
            });
          }
        });
    } else {
      setPreviewData([]); // Limpiar datos si el modal no está abierto o no hay contenedor
    }
  }, [isOpen, Contenedor?.IdContenedor, t]);

  // [EXPERT]: Memoizar columnas para estabilidad y rendimiento
  const internalColumns = useMemo(() => {
    return columnasEsperadas.map((col) => (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        style={{
          minWidth: col.width,
          maxWidth: col.width,
          textAlign: "center",
        }}
      />
    ));
  }, []); // columnasEsperadas es estática y está fuera del componente

  const pedidoExpansionTemplate = useCallback(
    (data) => {
      return (
        <div className="p-3 table-historico-nested">
          <h5 className="nested-table-title">Pedido Número: {data.idpedido}</h5>
          <DataTable
            value={data.productos}
            scrollable
            responsiveLayout="scroll"
            tableStyle={{ minWidth: "2500px" }}
            className="p-datatable-sm"
          >
            {internalColumns}
          </DataTable>
        </div>
      );
    },
    [internalColumns],
  );

  return (
    <Dialog
      header={t.titulo}
      visible={isOpen}
      style={{ width: "95vw", height: "90vh" }}
      className="historico-dialog"
      modal
      contentStyle={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
      onHide={onClose}
    >
      <Toast ref={toast} />

      <TotalesEncabezadoHistoricoContenedor
        Contenedor={Contenedor}
        previewData={previewData}
      />

      {previewData.length > 0 && (
        <DataTable
          value={previewData}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={pedidoExpansionTemplate} // Ahora el template de expansión es para pedidos
          dataKey="idpedido"
          scrollable
          scrollHeight="100%"
          className="p-datatable-sm full-height-table"
          style={{ flex: "1 1 auto", height: "100%", minHeight: 0 }}
        >
          <Column expander style={{ width: "3em" }} />
          <Column
            field="idpedido"
            header="LISTADO POR PEDIDO (Expandir para ver detalles)"
            body={(rowData) => (
              <strong>Pedido Número: {rowData.idpedido}</strong>
            )}
          />
        </DataTable>
      )}

      <div className="p-dialog-footer">
        <Button
          id="btn-historico-contenedor-cerrar"
          label={"Cerrar"}
          icon="pi pi-times"
          className="p-button-secondary"
          onClick={onClose}
        />
      </div>
    </Dialog>
  );
};

export default HistoricoContenedorModal;
